import { render, staticRenderFns } from "./ruleTable.vue?vue&type=template&id=4455b627"
import script from "./ruleTable.vue?vue&type=script&lang=js"
export * from "./ruleTable.vue?vue&type=script&lang=js"
import style0 from "./ruleTable.vue?vue&type=style&index=0&id=4455b627&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports